import { ReactElement, useEffect, useState } from 'react';
import { IMetaLocationClosedDates, IPageLocationFields } from 'types/contentful';
import DoctorOfficeDetails, { OfficeHours } from './DoctorOfficeDetails';
import { Add, Remove } from '@material-ui/icons';

interface OfficeLocationCardProps {
  index: number;
  location: IPageLocationFields;
  closedDates: IMetaLocationClosedDates | undefined;
  siteName: string;
  markerIcon: string;
  factua?: boolean;
  providerId?: string;
}

export default function OfficeLocationCard({
  index,
  location,
  closedDates,
  siteName,
  markerIcon,
  factua = false,
  providerId,
}: OfficeLocationCardProps): ReactElement {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (index === 0) {
      setOpen(true);
    }
  }, [index]);

  const officeInfo = { ...location };

  const locationDetailsCTA = [
    {
      title: 'view-location-details',
      text: 'View Location Details',
      slug: `locations/${location.slug}`,
      linkToAsset: undefined,
      colorScheme: 'OutlinedTeal' as const,
      openInNewTab: false,
    },
  ];

  return (
    <div className="bg-white">
      <div className="flex justify-between items-center py-5 p-4 md:px-10 lg:px-16 border-b border-gray-300">
        <h2 className="md:text-2xl text-xl text-primary-actual">{officeInfo.name}</h2>
        <button
          onClick={() => setOpen(!open)}
          className="bg-muted text-secondary-actual focus:outline-none rounded-md w-8 h-8 flex items-center justify-center"
          aria-label={open ? 'Collapse office details' : 'Expand office details'}
        >
          {open ? <Remove style={{ fontSize: '24px' }} /> : <Add style={{ fontSize: '24px' }} />}
        </button>
      </div>
      {open && (
        <DoctorOfficeDetails
          siteName={siteName}
          officeName={officeInfo.name}
          hideEyeOnPin={true}
          hours={officeInfo.hours as OfficeHours}
          hoursNotes={officeInfo.hoursNotes}
          markerIcon={markerIcon}
          center={{
            lat: officeInfo.map.lat,
            lng: officeInfo.map.lon,
          }}
          closedDates={closedDates}
          officeInfo={officeInfo}
          cta={locationDetailsCTA}
          location={location}
          zoom={10}
          factua={factua}
          providerId={providerId}
        />
      )}
    </div>
  );
}
